<template>
  <div class="case">
    <banner :img="sty" title="精典案例" />
    <!-- <div class="case-section">
      <div class="case_div">
        <div class=" divB"><img src="@/assets/home/a1.png" alt="" /></div>
        <div class="divB divL divR">
          <img src="@/assets/home/a2.png" alt="" />
        </div>
        <div class="divB "><img src="@/assets/home/a3.png" alt="" /></div>
        <div><img src="@/assets/home/a4.png" alt="" /></div>
        <div class="divL divR"><img src="@/assets/home/a5.png" alt="" /></div>
        <div><img src="@/assets/home/a6.png" alt="" /></div>
      </div> -->
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner,
  },
  data() {
    return {
      sty: {
        // backgroundImage: "url(" + require("@/assets/home/banner3.png") + ")",
      },
      loading: true,
      caseList: [],
    };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.divR {
  border-right: 1px solid #bfbfbf;
}
.divB {
  border-bottom: 1px solid #bfbfbf;
}
.divL {
  border-left: 1px solid #bfbfbf;
}

.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  .case-section {
    height: 60vh;
    background-color: #ededed;
    // background-image: url(../assets/home/back1.png);
    background-position: center;
    background-size: 100%;
    display: grid;
    place-items: center;
    .case_div {
      width: 60%;
      height: 70%;
      margin: auto;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      div {
        //  border: 1px red solid;

        display: grid;
        place-items: center;
        img {
       max-width: 160px;
          height: auto;
        }
      }
    }
  }
}
</style>
